import React, { useState, useEffect } from 'react';

import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import db from "./Firebase";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { CSVLink } from "react-csv";

function WorkshopFeedback() {
    const navigate = useNavigate();
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [csvdata, setCsvdata] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [lastVisible, setLastVisible] = useState(null);
    const [hasMore, setHasMore] = useState(true);

    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");

        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate('/signin');
        }
    }, []);

    const headers = [
        "Workshop Name",
        'Full Name',
        "Phone No",
        "Feedback",
        "Rating",
        "Created Date",
    ];

    useEffect(() => {
        const fetchData = async () => {
            const snapshot = await db.collection("workshop_feedback")
                .orderBy("created_date", "desc")
                .limit(20)
                .get();

            const lastVisible = snapshot.docs[snapshot.docs.length - 1];
            setLastVisible(lastVisible);

            setData(snapshot.docs.map((doc) => ({
                id: doc.id,
                data: doc.data(),
            })));
        };

        fetchData();
    }, []);

    const loadMoreData = async () => {
        const snapshot = await db.collection("workshop_feedback")
            .orderBy("created_date", "desc")
            .startAfter(lastVisible)
            .limit(20)
            .get();

        const lastVisible = snapshot.docs[snapshot.docs.length - 1];
        setLastVisible(lastVisible);

        if (snapshot.docs.length < 20) {
            setHasMore(false);
        }

        setData((prevData) => [
            ...prevData,
            ...snapshot.docs.map((doc) => ({
                id: doc.id,
                data: doc.data(),
            })),
        ]);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredData = data.filter((item) => {
        const workshop_name = item.data.workshop_name.toLowerCase();
        const full_name = item.data.full_name.toLowerCase();
        const phone_no = item.data.phone_no.toLowerCase();
        const query = searchQuery.toLowerCase();

        return (
            workshop_name.includes(query) ||
            full_name.includes(query) ||
            phone_no.includes(query)
        );
    });

    const prepareCSVData = () => {
        const csvData = filteredData.map((item) => ([
            item.data.workshop_name,
            item.data.full_name,
            item.data.phone_no,
            item.data.feedback,
            item.data.rating,
            moment(item.data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a"),
        ]));

        return csvData;
    };

    return (
        <>
            <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
                <div class="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
                    <Link to="/">
                        <img src="/images/menubutton.png" class="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} />
                    </Link>
                    <CSVLink data={prepareCSVData()} headers={headers} filename={"workshopFeedback.csv"}>
                        <span class="btn bg-gradient-secondary btn-sm mb-0 mr-2" style={{ color: "white" }}>
                            &nbsp; Download Excel
                        </span>
                    </CSVLink>
                </div>
                <div class="">
                    <div class="p-2">
                        <div class="card">
                            <div class="card-header pb-0 px-3">
                                <h6 class="mb-2">All Feedback || {`Records : ${filteredData.length}`}</h6>
                            </div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Search by Workshop Name, Full Name, Phone No, Rating"
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                            <div class="card">
                                <div class="table-responsive fix-width scroll-inner">
                                    <table class="table table-bordered table-hover">
                                        <thead class="thead-dark" style={{ position: "sticky", top: "0" }}>
                                            <tr style={{ textAlign: "left" }}>
                                                <th class="col ps-2">S.No</th>
                                                <th class="col ps-2">Workshop Name</th>
                                                <th class="col ps-2">Full Name</th>
                                                <th class="col ps-2">Phone No</th>
                                                <th class="col ps-2">Rating</th>
                                                <th class="col ps-2">Feedback</th>
                                                <th class="col ps-2">Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ textAlign: "left" }}>
                                            {filteredData.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>
                                                        <p class="text-xs mb-0">{index + 1}.</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{item.data.workshop_name}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{item.data.full_name}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{item.data.phone_no}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{item.data.rating}</p>
                                                    </td>
                                                    <td style={{ whiteSpace: 'pre-wrap' }}>
                                                        <p class="text-xs font-weight-bold mb-0" style={{ width: "25rem" }}>{item.data.feedback}</p>
                                                    </td>
                                                    <td>
                                                        <div class="d-flex px-2 py-1">
                                                            <div class="d-flex flex-column justify-content-center">
                                                                <h6 class="mb-0 text-xs">{moment(item.data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</h6>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {hasMore && (
                                        <div className="" style={{ paddingTop: "2rem" }}>
                                            <button onClick={loadMoreData} className="btn btn-dark">Load More</button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

export default WorkshopFeedback;


// import React, { useState, useEffect } from 'react';

// import { useNavigate, Link, useParams } from 'react-router-dom';
// import Swal from 'sweetalert2'
// import db from "./Firebase";
// import { arrayUnion } from "firebase/firestore";
// import { storage } from './Firebase';
// import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// import Moment from 'moment';
// import { extendMoment } from 'moment-range';
// import ViewAllRequests from './ViewAllRequests';
// import ViewAppData from './ViewAppData';
// import { CSVLink } from "react-csv";

// function WorkshopFeedback() {
//     const navigate = useNavigate();
//     const moment = extendMoment(Moment);
//     const [data, setData] = useState([]);
//     const [csvdata, setCsvdata] = useState([]);
//     const [uid, setUid] = useState('');
//     const [searchQuery, setSearchQuery] = useState("");

//     useEffect(() => {
//         const storedUsername = localStorage.getItem("email");
//         const storedPassword = localStorage.getItem("password");
//         const storedRemember = localStorage.getItem("remember");

//         if (storedRemember === "false" || !storedUsername || !storedPassword) {
//             navigate('/signin');
//         }
//     }, []);

//     const headers = [
//         "Workshop Name",
//         'Full Name',
//         "Phone No",
//         "Feedback",
//         "Rating",
//         "Created Date",
//         // Add more column labels as needed
//     ];

//     useEffect(() => {

//         db.collection("workshop_feedback").orderBy("created_date", "desc").onSnapshot((snapshot) => {
//             setData(
//                 snapshot.docs.map((doc) => ({
//                     id: doc.id,
//                     data: doc.data(),
//                 }))
//             );
//         });

//     }, []);

//     const handleSearchChange = (event) => {
//         setSearchQuery(event.target.value);
//     };


//     // Function to filter data based on the search query
//     const filteredData = data.filter((item) => {
//         const workshop_name = item.data.workshop_name.toLowerCase();
//         const full_name = item.data.full_name.toLowerCase();
//         const phone_no = item.data.phone_no.toLowerCase();
//         // const rating = item.data.rating.toLowerCase();
//         const query = searchQuery.toLowerCase();

//         return (
//             workshop_name.includes(query) ||
//             full_name.includes(query) ||
//             phone_no.includes(query)
//             //  ||
//             // rating.includes(query)
//         );
//     });

//     // Function to convert data to CSV format
//     const prepareCSVData = () => {
//         const csvData = filteredData.map((item, index) => ([
//             item.data.workshop_name,
//             item.data.full_name,
//             item.data.phone_no,
//             item.data.feedback,
//             item.data.rating,
//             moment(item.data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a"),
//             // Add more columns as needed
//         ]));

//         return csvData;
//     };






//     return (
//         <>
//             <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">

//                 <div class="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
//                     <Link to="/">
//                         <img src="/images/menubutton.png" class="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} />
//                     </Link>
//                     <CSVLink data={prepareCSVData()} headers={headers} filename={"workshopFeedback.csv"}>
//                         <span class="btn bg-gradient-secondary btn-sm mb-0 mr-2" style={{ color: "white" }}>
//                             &nbsp; Download Excel
//                         </span>
//                     </CSVLink>
//                 </div>
//                 <div class="">

//                     <div class="p-2">
//                         <div class="card">
//                             <div class="card-header pb-0 px-3">
//                                 <h6 class="mb-2">All Feedback || {`Records : ${filteredData.length}`}</h6>
//                             </div>
//                             <input
//                                 type="text"
//                                 className="form-control form-control-sm"
//                                 placeholder="Search by Workshop Name, Full Name, Phone No, Rating"
//                                 value={searchQuery}
//                                 onChange={handleSearchChange}
//                             />
//                             <div class="card">
//                                 <div class="table-responsive fix-width scroll-inner">
//                                     <table class="table table-bordered table-hover">
//                                         <thead class="thead-dark" style={{ position: "sticky", top: "0" }}>
//                                             <tr style={{ textAlign: "left" }}>
//                                                 <th class="col ps-2">S.No</th>
//                                                 <th class="col ps-2">Workshop Name</th>
//                                                 <th class="col ps-2">Full Name</th>
//                                                 <th class="col ps-2">Phone No</th>
//                                                 <th class="col ps-2">Rating</th>
//                                                 <th class="col ps-2">Feedback</th>
//                                                 <th class="col ps-2">Created Date</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody style={{ textAlign: "left" }}>
//                                             {filteredData.map((item, index) => (
//                                                 <tr key={item.id}>
//                                                     <td>
//                                                         <p class="text-xs mb-0">{index + 1}.</p>
//                                                     </td>
//                                                     <td>
//                                                         <p class="text-xs mb-0">{item.data.workshop_name}</p>
//                                                     </td>
//                                                     <td>
//                                                         <p class="text-xs mb-0">{item.data.full_name}</p>
//                                                     </td>
//                                                     <td>
//                                                         <p class="text-xs mb-0">{item.data.phone_no}</p>
//                                                     </td>
//                                                     <td>
//                                                         <p class="text-xs mb-0">{item.data.rating}</p>
//                                                     </td>
//                                                     <td style={{ whiteSpace: 'pre-wrap' }}>
//                                                         <p class="text-xs font-weight-bold mb-0" style={{ width: "25rem" }}>{item.data.feedback}</p>

//                                                     </td>


//                                                     <td>
//                                                         <div class="d-flex px-2 py-1">
//                                                             <div class="d-flex flex-column justify-content-center">
//                                                                 <h6 class="mb-0 text-xs">{moment(item.data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</h6>
//                                                             </div>
//                                                         </div>
//                                                     </td>

//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </main>
//         </>
//     );
// }

// export default WorkshopFeedback;
